<template>
    <v-app>
      <v-main>
        <v-container class="mt-6 text-center">
          <h1 class="text-h4 mb-2">Page Not Found</h1>
          <p class="text-subtitle-1">The page you are looking for does not exist.</p>
          <v-btn class="mt-4" color="primary" @click="$router.push('/')">Go Home</v-btn>
        </v-container>
      </v-main>
    </v-app>
  </template>
  
  <script>
  export default {}
  </script>
  